import React from 'react';
import { ProjectCellContainer } from '../styles';

const ProjectEmptyCell = ({ row }) => (
  <ProjectCellContainer height={row?.original?.itemHeight} />
);

export default ProjectEmptyCell;
